module.exports = __webpack_public_path__ + "img/KS.e65702b5.png";